import { Box } from '@mantine/core';
import type { ReactNode } from 'react';
import { Init } from '../ui';
import { MobileOrientationModal } from '../ui/MobileOrientationModal';
import styles from './Layout.module.css';

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <Box data-test-id="layout-container" display="flex" h="100%" mih="100dvh">
      <MobileOrientationModal />

      <main
        className={styles['main-content']}
        data-test-id="layout-main-content"
      >
        <Init>{children}</Init>
      </main>
    </Box>
  );
};
